var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAsset(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 19,
    viewBox: "0 0 7 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.49999 18.8838C1.57009 18.8838 0 17.5044 0 15.8089V5.48353C0 5.24575 0.219409 5.05297 0.490067 5.05297C0.760725 5.05297 0.980149 5.24575 0.980149 5.48353V15.8089C0.980149 17.0296 2.11054 18.0227 3.49999 18.0227C4.88945 18.0227 6.01984 17.0296 6.01984 15.8089V3.24452C6.01984 2.41762 5.2541 1.7449 4.31289 1.7449C3.37168 1.7449 2.60594 2.41762 2.60594 3.24452V12.9306C2.60594 13.3637 3.00701 13.716 3.49999 13.716C3.99298 13.716 4.39405 13.3637 4.39405 12.9306V5.48353C4.39405 5.24575 4.61346 5.05297 4.88413 5.05297C5.1548 5.05297 5.37421 5.24575 5.37421 5.48353V12.9306C5.37421 13.8385 4.53344 14.5771 3.49999 14.5771C2.46655 14.5771 1.62579 13.8385 1.62579 12.9306V3.24452C1.62579 1.94282 2.83123 0.883789 4.31289 0.883789C5.79455 0.883789 7 1.94282 7 3.24452V15.8089C7 17.5044 5.4299 18.8838 3.49999 18.8838Z",
    fill: "#596975"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset);
export default __webpack_public_path__ + "static/media/asset.1b94db0388ec21c079903cd91bca412e.svg";
export { ForwardRef as ReactComponent };